const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

export const API_BASE = configuredBackendUrl ? `${configuredBackendUrl}/api` : null;

export const API_UNAVAILABLE_MESSAGE =
  "Online submissions are unavailable in this preview. Please contact us directly.";
